import { Container, Row, Col, Card } from "react-bootstrap";
import "./tutorial.scss";
import { Tutorial } from "./tut-data";
// import { TutorialCard } from "./TutorialCard";
import { HoverCard } from "../../../common/hover-cards/HoverCards";
import { ArrowPointer } from "../../../common/navigating-arrow/ArrowPointer";

export const TutorialCards = () => {
  return (
    <Container fluid>
      <div className="tutorial-parent-header">
        <p
          className="tutorial-header-text fw-bold text-center my-5"
          data-aos="fade-down"
          data-aos-easing="linear"
          data-aos-duration="500"
          data-aos-once="false"
        >
          Make a wish in 3 easy steps
        </p>
      </div>
      <div className="tutorial-card-container d-flex flex-nowrap overflow-auto">
        {Tutorial.map((data, key) => (
          <div key={key} className="mx-3 my-5">
            <HoverCard data={data} />
          </div>
        ))}
      </div>
      <ArrowPointer/>
    </Container>
  );
};
